import React from 'react';
import PropTypes from 'prop-types';

const EmptyKeyMsg = 'i18n.empty.key';

/* istanbul ignore next */
const fetchTranslation = (dict, key, args = false) => {
    const trans = key.split('.').reduce((o, i) => o[i] || '', dict);

    if (!trans) return key;
    if (!args) return trans;

    return Object.keys(args).reduce((prev, curr) =>
        prev.replace(new RegExp('{%\\s*' + curr + '\\s*%}', 'g'), args[curr]), trans);
};

const Context = React.createContext();

const I18nProvider = ({ translations, children }) => (
    <Context.Provider value={{
        translations,
        translate: (key, args = false) => fetchTranslation(translations, key || EmptyKeyMsg, args),
    }}>
        {children}
    </Context.Provider>
);
I18nProvider.propTypes = {
    translations: PropTypes.any,
    children: PropTypes.any,
};

const I18n = ({ children, args }) => {
    const { translate } = React.useContext(Context);
    return translate(children, args);
};
I18n.propTypes = {
    children: PropTypes.string,
    args: PropTypes.object,
};

export {
    I18nProvider,
    Context as I18nContext,
    I18n
};

